export const ConnectionPendingTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                Your solar system <span className="font-semibold">monitoring is in the setup process.</span>
            </li>
            <li>
                <span className="font-semibold">No immediate action</span> is needed as setup is expected to
                complete within two weeks.
            </li>
            <li>
                <span className="font-semibold">Monitor</span> the status periodically in the manufacturer's
                monitoring portal.
            </li>
        </ul>
    </div>
